/**
 * Query to fetch marketplace_users for a given org
 */
const orgUsersQuery = `
query MarketplaceOrgUsers($first: Int!, $skip: Int, $where: Marketplace_userWhereInput) {
  marketplace_users(
    first: $first,
    skip: $skip,
    where: $where,
    order: [createdAt_DESC]
  ) {
    count
    edges {
      node {
        objectId
        email
        first_name
        last_name
        phone
        is_active
        marketplace_org_pointer {
          objectId
          name
        }
        createdAt
        updatedAt
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default orgUsersQuery;
